import { Button, Card, Col, Form, Input, InputNumber, Row } from "antd";
import React from "react";
import { api_testEval, api_testInfer } from "../../services/submission";

type Props = {};

const TestSubmit = (props: Props) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const submit1 = async (value: any) => {
    const result = {
      json: value.json,
      round: Number(value.round),
    };
    await api_testEval(result);
  };
  const submit2 = async (value: any) => {
    const result = {
      json: value.json,
      round: Number(value.round),
    };
    await api_testInfer(result);
  };
  return (
    <div>
      <Row justify={"center"} style={{ marginTop: "4rem" }}>
        <Col xs={20}>
          <Card
            title="Test Eval JSON"
            actions={[
              <Button
                onClick={async () => {
                  form.submit();
                }}
              >
                Send Eval
              </Button>,
            ]}
          >
            <Form form={form} onFinish={submit1} initialValues={{ round: 1 }}>
              <Form.Item name="json" label="json">
                <Input.TextArea rows={5} />
              </Form.Item>
              <Form.Item name="round" label="round">
                <InputNumber min={1} />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <Row justify={"center"} style={{ marginTop: "4rem" }}>
        <Col xs={20}>
          <Card
            title="Test Infer JSON"
            actions={[
              <Button
                onClick={async () => {
                  form2.submit();
                }}
              >
                Send Infer
              </Button>,
            ]}
          >
            <Form form={form2} onFinish={submit2} initialValues={{ round: 1 }}>
              <Form.Item name="json" label="json">
                <Input.TextArea rows={5} />
              </Form.Item>
              <Form.Item name="round" label="round">
                <InputNumber min={1} />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TestSubmit;
